var App = App || {};

App.SolutionsFinder = (function ($) {
    'use strict';

    var LgBp = 992,
        winTouchPoint;

    function init() {
        $(".solutionsfinder-item").click(function () {
            if ($(window).outerWidth() < LgBp && $(this).attr("aria-selected") == "true") {
                removeFocus($(this));
            }
            else {
                giveFocus($(this));
            }
        });        

        $(document).ready(function () {
            winTouchPoint = $(window).outerWidth();
            if ($(window).outerWidth() < LgBp) {
                unselectAllItems();
            }
        });

        $(window).resize(function () {
            if ($(window).outerWidth() >= LgBp && winTouchPoint < LgBp) {
                winTouchPoint = $(window).outerWidth();
                $(".solutionsfinder-item").first().attr("aria-selected", "true");
            } else if ($(window).outerWidth() < LgBp && winTouchPoint >= LgBp) {
                winTouchPoint = $(window).outerWidth();
                unselectAllItems();
            }
        });
    }

    function unselectAllItems() {
        $(".solutionsfinder-item[aria-selected=true]").each(function () {
            $(this).attr("aria-selected", "false");
        });
    }

    function giveFocus(elem) {
        //remove focus from all items
        $(".solutionsfinder-item").each(function (index) {
            removeFocus($(this));
        });
        //add focus to selected item and show associated panel
        elem.attr("aria-selected", "true");

        if ($(window).outerWidth() < LgBp) {
            $("#solutionsfinder-item-mobile-panel-" + elem.data("id")).removeAttr("hidden").attr("aria-expanded", "true");
        }
        else {
            $("#solutionsfinder-item-panel-" + elem.data("id")).removeAttr("hidden").attr("aria-expanded", "true");
        }
    }
    function removeFocus(elem) {
        elem.attr("aria-selected", "false");

        if ($(window).outerWidth() < LgBp) {
            $("#solutionsfinder-item-mobile-panel-" + elem.data("id")).attr("hidden", "true").attr("aria-expanded", "false");
        }
        else {
            $("#solutionsfinder-item-panel-" + elem.data("id")).attr("hidden", "true").attr("aria-expanded", "false");
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.SolutionsFinder.init();
});